import Lottie from 'lottie-react'
import styles from './AnimatedIcon.module.css'
import starsJson from '@/assets/misc/lottie_stars.json'
import icTaxfyleLoopJson from '@/assets/misc/lottie_ic-taxfyle-loop.json'

export type AnimatedIconName = 'stars' | 'ic-taxfyle-loop'

const animatedIcons: Record<AnimatedIconName, unknown> = {
  stars: starsJson,
  'ic-taxfyle-loop': icTaxfyleLoopJson,
}

export interface AnimatedIconProps {
  name: AnimatedIconName
  /**
   * Width and height in pixels.
   *
   * @default 24
   */
  size?: number
}

/**
 * A looping Lottie animation.
 */
export function AnimatedIcon({ name, size = 24 }: AnimatedIconProps) {
  return (
    <Lottie
      animationData={animatedIcons[name]}
      loop
      style={{ width: `${size}px`, height: `${size}px` }}
      className={styles.animatedIcon}
    />
  )
}
